export const worldCupCalendar = [
  {
    season: 1,
    title: 'World Cupin aikataulu - osa 1',
    weeks: [
      {
        week: 1,
        cells: [
          'Vaalit\nÄänestys',
          'Vaalit\nÄänestys',
          'Vaalit\nÄänestys',
          'Vaalit\nÄänestys',
          'Vaalit\nÄänestys\nLivearvonta\nYstävyysottelut',
          'Vaalit\nÄänestys',
          'Vaalit\nÄänestys',
        ],
      },
      {
        week: 2,
        cells: ['Vaalit\nTulokset', '-', '-', '-', '-', 'Ystävyysottelut', '-'],
      },
      {
        week: 3,
        cells: [
          '-',
          '-',
          'JH:n/IL:n palautus\n100%:n palautus',
          '-',
          'CC\nOttelu 1\nCL\nOttelu 1',
          '-',
          '-',
        ],
      },
      {
        week: 4,
        cells: [
          'CC\nOttelu 2\nCL\nOttelu 2',
          '-',
          '-',
          '-',
          'CC\nOttelu 3\nCL\nOttelu 3',
          '-',
          '-',
        ],
      },
      {
        week: 5,
        cells: [
          'CC\nOttelu 4\nCL\nOttelu 4',
          '-',
          '-',
          '-',
          'CC\nOttelu 5\nCL\nOttelu 5',
          '-',
          '-',
        ],
      },
      {
        week: 6,
        cells: ['-', '-', '-', '-', 'CC\nOttelu 6\nCL\nOttelu 6', '-', '-'],
      },
      {
        week: 7,
        cells: ['-', '-', '-', '-', 'CC\nOttelu 7\nCL\nOttelu 7', '-', '-'],
      },
      {
        week: 8,
        cells: ['-', '-', '-', '-', 'CC\nOttelu 8\nCL\nOttelu 8', '-', '-'],
      },
      {
        week: 9,
        cells: ['-', '-', '-', '-', 'CC\nOttelu 9\nCL\nOttelu 9', '-', '-'],
      },
      {
        week: 10,
        cells: ['-', '-', '-', '-', 'CC\nOttelu 10\nCL\nOttelu 10', '-', '-'],
      },
      {
        week: 11,
        cells: [
          '-',
          '-',
          '-',
          '-',
          'CC\nPuolivälierät',
          '-',
          'JH:n/IL:n palautus\n100%:n palautus\n(Vain villit kortit)',
        ],
      },
      {
        week: 12,
        cells: [
          'CC\nVälierät\nVK\nOttelu 1',
          '-',
          '-',
          '-',
          'CC\nFinaali\nVK\nOttelu 2\nLivearvonta',
          '-',
          '-',
        ],
      },
      {
        week: 13,
        cells: [
          '-',
          '-',
          'JH:n/IL:n palautus\n100%:n palautus',
          '-',
          'WC krs 1\nOttelu 1\nNC\nOttelu 1',
          '-',
          '-',
        ],
      },
      {
        week: 14,
        cells: [
          'WC krs 1\nOttelu 2',
          '-',
          '-',
          '-',
          'WC krs 1\nOttelu 3\nNC\nOttelu 2',
          '-',
          '-',
        ],
      },
      {
        week: 15,
        cells: [
          '-',
          '-',
          '-',
          '-',
          'WC krs 1\nOttelu 4\nNC\nOttelu 3',
          '-',
          '-',
        ],
      },
      {
        week: 16,
        cells: [
          '-',
          '-',
          '-',
          '-',
          'WC krs 1\nOttelu 5\nNC\nOttelu 4',
          '-',
          '-',
        ],
      },
    ],
  },
  {
    season: 2,
    title: 'World Cupin aikataulu - osa 2',
    weeks: [
      {
        week: 1,
        cells: [
          '-',
          '-',
          '-',
          '-',
          'WC krs 1\nOttelu 6\nNC\nOttelu 5',
          '-',
          '-',
        ],
      },
      {
        week: 2,
        cells: [
          '-',
          '-',
          '-',
          '-',
          'WC krs 1\nOttelu 7\nNC\nOttelu 6',
          '-',
          '-',
        ],
      },
      {
        week: 3,
        cells: [
          '-',
          '-',
          '-',
          '-',
          'WC krs 1\nOttelu 8\nNC\nOttelu 7',
          '-',
          '-',
        ],
      },
      {
        week: 4,
        cells: [
          '-',
          '-',
          '-',
          '-',
          'WC krs 1\nOttelu 9\nNC\nOttelu 8',
          '-',
          '-',
        ],
      },
      {
        week: 5,
        cells: [
          '-',
          '-',
          '-',
          '-',
          'WC krs 1\nOttelu 10\nNC\nOttelu 9',
          '-',
          '-',
        ],
      },
      {
        week: 6,
        cells: [
          '-',
          '-',
          'JH:n/IL:n palautus\n80%:n palautus\n(Vain WC)',
          '-',
          'WC krs 2\nOttelu 1\nNC\nOttelu 10',
          '-',
          '-',
        ],
      },
      {
        week: 7,
        cells: [
          'WC krs 2\nOttelu 2',
          '-',
          '-',
          '-',
          'WC krs 2\nOttelu 3\nNC\nOttelu 11',
          '-',
          '-',
        ],
      },
      {
        week: 8,
        cells: [
          'WC krs 2\nOttelu 4',
          '-',
          '-',
          '-',
          'WC krs 2\nOttelu 5\nNC\nOttelu 12',
          '-',
          '-',
        ],
      },
      {
        week: 9,
        cells: [
          '-',
          '-',
          '-',
          '-',
          'WC krs 2\nOttelu 6\nNC\nOttelu 13',
          '-',
          '-',
        ],
      },
      {
        week: 10,
        cells: [
          '-',
          '-',
          'JH:n/IL:n palautus\n60%:n palautus\n(Vain WC)',
          '-',
          'WC krs 3\nOttelu 1\nNC\nOttelu 14',
          '-',
          '-',
        ],
      },
      {
        week: 11,
        cells: [
          'WC krs 3\nOttelu 2',
          '-',
          '-',
          '-',
          'WC krs 3\nOttelu 3\nNC\nOttelu 15',
          '-',
          '-',
        ],
      },
      {
        week: 12,
        cells: [
          '-',
          '-',
          'JH:n/IL:n palautus\n40%:n palautus\n(Vain WC)',
          '-',
          'WC krs 4\nOttelu 1\nNC\nOttelu 16',
          '-',
          '-',
        ],
      },
      {
        week: 13,
        cells: [
          'WC krs 4\nOttelu 2',
          '-',
          '-',
          '-',
          'WC krs 4\nOttelu 3\nNC\nOttelu 17',
          '-',
          '-',
        ],
      },
      {
        week: 14,
        cells: [
          '-',
          '-',
          '-',
          '-',
          'WC krs 5\nOttelu 1\nNC\nPuolivälierät',
          '-',
          '-',
        ],
      },
      {
        week: 15,
        cells: [
          'WC krs 5\nOttelu 2',
          '-',
          '-',
          '-',
          'WC krs 5\nOttelu 3\nNC\nVälierät',
          '-',
          '-',
        ],
      },
      {
        week: 16,
        cells: [
          'WC\nVälierät',
          '-',
          '-',
          '-',
          'WC\nFinaali\nNC\nFinaali',
          '-',
          '-',
        ],
      },
    ],
  },
]
